import localforage from "localforage";
import Offline from "./Offline";
import Api from "../core/Api";

class InformationInstallation
{

    static getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listInformationInstallation')
                .then(res => { const parsed = JSON.parse(res); resolve(Array.isArray(parsed) ? parsed : []) })
                .catch(err => reject(err))
        })
    }

    static getListByInstallation(installation) {

        return new Promise((resolve, reject) => {
            this.getList()
                .then(list => {
                    let informations = _.filter(list, {installation: installation});

                    resolve(informations);
                })
                .catch(err => reject(err))
        })
    }

    static addInformationInstallationOffline(data) {

        return new Promise(async (resolve, reject) => {

            //On est en local
            if (typeof data.id !== 'undefined') {
                await this.removeInformationInstallationOffline(data.id);
            }

            let informationInstallation = data;

            informationInstallation.id = 'N-' + Date.now();

            this.getList()
                .then(list => {
                    list.push(informationInstallation);

                    localforage
                        .setItem('listInformationInstallation', JSON.stringify(list))
                        .then(() => {
                            return Offline.saveAction({
                                action: 'add',
                                type: 'InformationInstallation',
                                id: informationInstallation.id,
                            })
                        }).then(() => {
                        resolve(true)
                    }).catch(err => reject(err));
                })
        });
    }

    static getInformationInstallation(id) {
        return new Promise((resolve, reject) => {

            localforage
                .getItem('listInformationInstallation')
                .then(res => {
                    let informations = JSON.parse(res);
                    let information = _.find(informations, {id: id});

                    if(information !== undefined) {
                        resolve(information);
                    } else{
                        reject(id);
                    }
                })

        });
    }

    static addInformationInstallationOnline(data) {

        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .post('/installation/information/add', data)
                        .then(result => {
                            if(result.status === 200) {
                                resolve(true);
                            }else{
                                reject(result.data);
                            }
                        }).catch(err => reject(err))
                }).catch(err => reject(err))

        })
    }

    static removeInformationInstallationOffline(id) {
        return new Promise((resolve, reject) => {
            this.getList()
                .then(list => {

                    _.remove(list, function(nl) {
                        return nl.id === id;
                    });


                    localforage
                        .setItem('listInformationInstallation', JSON.stringify(list))
                        .then(function() {

                            Offline
                                .getList()
                                .then(listOffline => {

                                    _.remove(listOffline, function(lo) {
                                        return lo.id === id && lo.type === 'InformationInstallation' && lo.action === 'add';
                                    });

                                    localforage
                                        .setItem('offlineActions', JSON.stringify(listOffline))
                                        .then(() => {
                                            resolve(true);
                                        })

                                })
                        }).catch(err => reject(err));
                })
        });
    }

}
export default InformationInstallation;



// WEBPACK FOOTER //
// ./src/js/models/InformationInstallation.js